import { Text } from '@mantine/core'

import { showAsyncConfirmModal, showError } from '#components/Modals'

import { seatChangeFailure } from '../Members/useSeatChanges'

import { scheduleAfterKeep, seatsAtRenewal } from './seatMath'
import { WorkspaceSeatData } from './types'

export const seatActions = (
  workspace: WorkspaceSeatData,
  setSeats: (quantity: number) => Promise<unknown>,
) => {
  const { licensed } = workspace.seats
  const atRenewal = seatsAtRenewal(workspace)
  const isAnnual = workspace.seatMode === 'static'
  const afterRemoval = isAnnual ? atRenewal - 1 : licensed - 1

  const removeSeat = () =>
    showAsyncConfirmModal({
      title: 'Remove seat',
      children: isAnnual ? (
        <Text>
          This seat will be removed when your annual plan renews
          {workspace.renewalLabel ? ` on ${workspace.renewalLabel}` : ''}. It
          will remain available until then.
        </Text>
      ) : (
        <Text>
          This seat will be immediately removed, and your next invoice will be
          credited a prorated amount.
        </Text>
      ),
      confirmLabel: isAnnual ? 'Schedule removal' : 'Remove',
      errorMessage: (e) =>
        seatChangeFailure(
          e,
          isAnnual
            ? 'Failed to schedule the seat removal'
            : 'Failed to remove the seat',
        ).message,
      dangerous: !isAnnual,
      onConfirm: async () => {
        await setSeats(afterRemoval)
      },
    })

  const keepSeat = async () => {
    try {
      await setSeats(scheduleAfterKeep(atRenewal, licensed))
    } catch (e) {
      showError({ message: seatChangeFailure(e).message })
    }
  }

  return { removeSeat, keepSeat }
}
